import { TextField, styled } from "@mui/material";
import type { TextFieldProps } from "@mui/material";

export const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
	"& .MuiOutlinedInput-root": {
		backgroundColor: theme.palette.background.paper,
	},
}));
